import { useState, useEffect, useMemo } from 'react';
import { expertListApi } from '../../api/expert-list.api';
import type { GetExpertsFilterParams } from '../../api/expert-list.api';
import type { Expert } from '../../components/experts/expert.type'; 

export const useExpertList = (filters: GetExpertsFilterParams) => {
  const [baseExperts, setBaseExperts] = useState<Expert[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchExperts = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const data = await expertListApi.getExpertsList(filters);
        
        const mappedData: Expert[] = data.map((item: any) => ({
          expertCode: item.expert_code,
          category: item.category || 'N/A',
          categoryId: item.category_id ? Number(item.category_id) : undefined, 
          name: item.expert_name,
          specialty: item.specialization || 'Consultant',
          experience: item.experience ? `${item.experience} Years` : 'N/A',
          rating: Number(item.ratings) || 0,
          languages: 'English, Hindi', 
        price: Number(
  sessionStorage.getItem('guest_country') === 'IN'
    ? item.actual_rate
    : item.actual_rate_for_usa
) || 0,
          isOnline: item.is_online,
          isVerified: item.account_status === 'approved',
          isFeatured: item.is_featured_expert,
          isUserChoice: false,
          isSupreme: item.is_supreme_expert,
          image: item.profile_pic || 'https://i.pravatar.cc/150?img=11', 
          
          isNew: item.is_new === true, 
          
          // 🟢 FIXED: Map the exact SQL columns to your frontend states!
          isAvailableChat: item.is_available_chat,
          isAvailableCall: item.is_available_call,
          isAvailableVideoCall: item.is_available_video_call,
        }));

        setBaseExperts(mappedData);
        setLoading(false); 
        
      } catch (err) {
        console.error('Failed to fetch experts:', err);
        setBaseExperts([]);
        setError("Failed to load experts");
        setLoading(false); 
      }
    };

    fetchExperts();
  }, [JSON.stringify(filters)]); 

  const derivedData = useMemo(() => {
    return {
      baseExperts,
      supremeExperts: baseExperts.filter(expert => expert.isSupreme),
      featuredExperts: baseExperts.filter(expert => expert.isFeatured),
    };
  }, [baseExperts]);

  return { ...derivedData, loading, error };
};